var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.698,
    height: 21.872,
    viewBox: "0 0 24.698 21.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svgicon-community-a{fill:none;opacity:0.18;}.svgicon-community-b,.svgicon-community-c{fill:#01c6d9;}.svgicon-community-c{stroke:#01c6d9;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "svgicon-community-a",
    width: 21.872,
    height: 21.872,
    transform: "translate(18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.717 2.414)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "svgicon-community-b",
    cx: 2.267,
    cy: 2.267,
    r: 2.267,
    transform: "translate(18.682 2.991)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svgicon-community-b",
    cx: 2.283,
    cy: 2.283,
    r: 2.283,
    transform: "translate(1.476 2.982)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "svgicon-community-c",
    cx: 3.298,
    cy: 3.286,
    rx: 3.298,
    ry: 3.286,
    transform: "translate(8.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-community-b",
    d: "M154.338,201.31h4a2.48,2.48,0,0,1,2.608,2.329v5.88H151.73v-5.88A2.48,2.48,0,0,1,154.338,201.31Z",
    transform: "translate(-144.077 -192.108)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-community-b",
    d: "M361.313,240.13h2.67a2.524,2.524,0,0,1,2.653,2.37v3.191a1.194,1.194,0,0,1-1.255,1.121h-4.008a.716.716,0,0,1-.753-.672v-5.39A.659.659,0,0,1,361.313,240.13Z",
    transform: "translate(-341.938 -230.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-community-b",
    d: "M.753,0H4.762A1.194,1.194,0,0,1,6.017,1.121V4.311A2.525,2.525,0,0,1,3.363,6.68H.693A.738.738,0,0,1,.2,6.5.587.587,0,0,1,0,6.06V.673A.716.716,0,0,1,.753,0Z",
    transform: "translate(6.017 16.72) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.6c4efa21.svg";
export { ForwardRef as ReactComponent };